import ApartmentTCList from "../../features/apartment/ApartmentTCList"
const ApartmentTCListPage = () => {
  return <ApartmentTCList/>
}

export default ApartmentTCListPage